/** @module MaterialSpecProductSpec/ExceptionRequestTime */
define([
	"dojo/_base/declare",
	"csi/heading/Time"
], function(declare,Time) {

	return declare(Time, {
		idStatus: "ExceptionRequestTime.Status",

		/**
		 * @override
		 * Refresh property and table views
		 */
		onMonitor: function(amc, newValue) {
			var sourceView = amc.ctx.view;
			var view;
			
			sourceView.redrawNode(refNode);

			if (view = sourceView.viewParent.getChildView("ReportPlacements")) {
				view.refreshWidget(true);
			}
			
			if (view = sourceView.viewParent.getChildView("ReportColors")) {
				view.refreshWidget(true);
			}

			return true;
		}
	});
});